import styled from '@emotion/styled'
import Title from 'components/Utilities/Title'
import Text from 'components/Utilities/Text'

export const GenericContainer = styled.div`
  position: relative;

  .HeroGeneric {
    padding-bottom: 0;

    > div {
      margin-top: 0;
    }
  }
`

export const GenericLayout = styled.div`
  max-width: 2000px;
  width: calc(100% - 40px);
  padding-top: 100px;
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 80px;
  z-index: 1;
  position: relative;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    width: calc(100% - 100px);
    margin-right: 50px;
    margin-left: 50px;
    padding-top: 200px;
  }

  @media (min-width: ${props => props.theme.breakpoints.l}) {
    width: calc(100% - 200px);
    margin-right: 100px;
    margin-left: 100px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xl}) {
    width: calc(100% - 376px);
    margin-right: 186px;
    margin-left: 186px;
  }
`

export const GenericTitle = styled(Title)`
  margin-bottom: 40px;
`

export const GenericBody = styled(Text)`
  font-weight: 200;
`
